export function hasSubdivisionOrZipCodeTaxError(_ref) {
  var _calculationErrors$ta, _calculationErrors$ta2, _calculationErrors$ta3, _calculationErrors$ta4;
  let {
    calculationErrors
  } = _ref;
  const hasTaxSubdivisionError = (_calculationErrors$ta = calculationErrors == null || (_calculationErrors$ta2 = calculationErrors.taxCalculationError) == null || (_calculationErrors$ta2 = _calculationErrors$ta2.validationError) == null || (_calculationErrors$ta2 = _calculationErrors$ta2.fieldViolations) == null ? void 0 : _calculationErrors$ta2.some(violationObject => violationObject.field === 'subdivision' && violationObject.description === 'MISSING')) != null ? _calculationErrors$ta : false;
  const hasTaxZipCodeError = (_calculationErrors$ta3 = calculationErrors == null || (_calculationErrors$ta4 = calculationErrors.taxCalculationError) == null || (_calculationErrors$ta4 = _calculationErrors$ta4.validationError) == null || (_calculationErrors$ta4 = _calculationErrors$ta4.fieldViolations) == null ? void 0 : _calculationErrors$ta4.some(violationObject => violationObject.field === 'postalCode' && violationObject.description === 'MISSING')) != null ? _calculationErrors$ta3 : false;
  return hasTaxSubdivisionError || hasTaxZipCodeError;
}
const shippingErrorFields = ['shippingDestination.subdivision', 'shippingDestination', 'postalCode'];
export function hasSubdivisionOrZipCodeShippingError(_ref2) {
  var _calculationErrors$ca, _calculationErrors$ca2;
  let {
    calculationErrors
  } = _ref2;
  return (_calculationErrors$ca = calculationErrors == null || (_calculationErrors$ca2 = calculationErrors.carrierErrors) == null || (_calculationErrors$ca2 = _calculationErrors$ca2.errors) == null ? void 0 : _calculationErrors$ca2.some(_ref3 => {
    var _error$validationErro;
    let {
      error
    } = _ref3;
    return error == null || (_error$validationErro = error.validationError) == null || (_error$validationErro = _error$validationErro.fieldViolations) == null ? void 0 : _error$validationErro.some(_ref4 => {
      let {
        field
      } = _ref4;
      return shippingErrorFields.includes(field);
    });
  })) != null ? _calculationErrors$ca : false;
}
//# sourceMappingURL=calculationError.utils.js.map